<template></template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "cookie-warning",

  created() {
    if (!this.$q.cookies.get("lgpd")) {
      this.$q.notify({
        message: `Este site utiliza somente cookies essenciais para operação do sistema. Ao utilizar nosso software,
        assumimos que você concorda com o uso de cookies para armazenar suas preferências.`,
        timeout: 0,
        actions: [
          {
            label: "Ok",
            color: "yellow",
            handler: () => {
              this.$q.cookies.set("lgpd", true);
            },
          },
        ],
      });
    }
  },
});
</script>

<style>
</style>